import { ValueOfKey } from '../../../utils-types';

export const CONSULTATION_TYPE = {
  REMOTE: 'REMOTE',
  OFFLINE: 'OFFLINE',
} as const;

export type ConsultationType = ValueOfKey<typeof CONSULTATION_TYPE>;
